import { TableName } from "./tableNames";
export type ColumnSchema = {
  type: "string" | "number" | "boolean";
  isPrimaryKey?: boolean;
  isArray?: boolean;
  isForeignKeyOf?: TableName | null;
  isNullable?: boolean;
  description?: string;
  isJson?: boolean;
};

// U is not required
export type TableSchema<U = any> = {
  tableName: TableName;
  columns: Record<keyof U, ColumnSchema>;
};

export function defineSchema<U>(schema: TableSchema<U>): TableSchema<U> {
  return schema;
}

type PrimitiveMap = {
  string: string;
  number: number;
  boolean: boolean;
};

// Helper tuple to decrement recursion depth
type Prev = [never, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

type InferColumn<
  C extends { type: keyof PrimitiveMap },
  Schemas extends Record<TableName, any>,
  Depth extends number = 8
> = [Depth] extends [0]
  ? PrimitiveMap[C["type"]]
  : C extends { isForeignKeyOf: infer FK }
  ? FK extends TableName
    ? C extends { isArray: true }
      ? InferSchema<Schemas[FK], Schemas, Prev[Depth]>[]
      : InferSchema<Schemas[FK], Schemas, Prev[Depth]>
    : PrimitiveMap[C["type"]]
  : PrimitiveMap[C["type"]];

export type InferSchema<
  S extends TableSchema,
  Schemas extends Record<TableName, any>,
  Depth extends number = 8
> = {
  [K in keyof S["columns"]]: InferColumn<S["columns"][K], Schemas, Depth>;
};
